<template>
  <form class="gift-card__form">
    <div class="gift-card__form-title">Оформление подарочной карты</div>

    <!--  Карты с данными получателей  -->
    <card-data-form v-for="(card, index) in cardsCount"
                    :key="index"
                    :cardNum="index"
                    @setCardFields="setFields"
                    @decreaseCard="decreaseCard"
                    @setDesignId="setDesignId"
                    :timezones="timezones"
                    :designs="cardDesigns"
                    :can-be-removed="removeCardEnable">
    </card-data-form>

    <button class="add-card" @click.prevent="increaseCard">Добавить еще карту</button>

    <!--  Данные плательщика  -->
    <div class="gift-card__form-item">
      <div class="gift-card__form-label">Данные плательщика</div>
      <div class="gift-card__col col-3 clearfix">
        <div class="form_row required" :class="{ 'error': $v.customer.lastName.$error }">
          <label>
            <span>Фамилия</span> <span class="req">*</span>
          </label>
          <input class="form-control" type="text" v-model="customer.lastName" name="cLastName" value="" required>
        </div>
        <div class="form_row required" :class="{ 'error': $v.customer.name.$error }">
          <label>
            <span>Имя</span><span class="req">*</span>
          </label>
          <input class="form-control" type="text" v-model="customer.name" name="cName" value="" required>
        </div>
        <div class="form_row required" :class="{ 'error': $v.customer.secondName.$error }">
          <label>
            <span>Отчество</span> <span class="req">*</span>
          </label>
          <input class="form-control" type="text" v-model="customer.secondName" name="cSecondName" value="" required>
        </div>
        <div class="form_row required" :class="{ 'error': $v.customer.phone.$error }">
          <label><span>Телефон </span> <span class="req">*</span></label>
          <input class="form-control mask-phone" type="text" @blur="updatePhone" name="cPhone" maxlength="" value="">
        </div>
        <div class="form_row required" :class="{ 'error': $v.customer.email.$error }">
          <label><span>E-mail </span> <span class="req">*</span></label>
          <input class="form-control" type="email" v-model="customer.email" name="cEmail" maxlength="" value="">
        </div>
      </div>
    </div>

    <!--  Итоговая сумма  -->
    <div class="gift-card__form-item gift-card__total">
      <div class="gift-card__form-label">Итоговая сумма:</div>
      <div class="summ" v-html="totalSum"></div>
    </div>
    <div class="gift-card__form-item gift-card__submit">
      <input type="submit" @click.prevent="addOrder" value="Оплата" class="btn btn_red">
      <div class="form-accept checkbox--agreement">
        <input id="agreement" class="form-control" :class="{ 'error': $v.customer.agreement.$error }" type="checkbox" name="agreement" v-model="customer.agreement">
        <label for="agreement">
          <p>Нажимая на кнопку «Оплата», Вы соглашаетесь с <a href="/upload/rules.pdf" target="_blank">Правилами</a> и<br>
            <a href="/upload/gift-rules.pdf" target="_blank">Политикой конфиденциальности</a>
          </p>
        </label>
      </div>
    </div>
    <div class="gift-card__form-info">* Поля обязательные для заполнения</div>

    <div class="gift-card__form-payment">
      <img class="gift-card__form-payment-img" src="/local/templates/.default/img/mir.svg" alt="мир" loading="lazy">
      <img class="gift-card__form-payment-img" src="/local/templates/.default/img/visa.svg" alt="visa" loading="lazy">
      <img class="gift-card__form-payment-img" src="/local/templates/.default/img/mastercard.svg" alt="master-card" loading="lazy">
      <img class="gift-card__form-payment-img" src="/local/templates/.default/img/jcb.svg" alt="jcb" loading="lazy">
    </div>

    <gift-popup v-if="modal.show" :message="modal.message"></gift-popup>

    <div id="card-design" class="popup_container" style="display: none;">
      <div class="popup_head"><span>Дизайн подарочной карты</span></div>
      <div class="popup_cont">
        <div class="card-design">
          <div class="card-design__top">
            <div class="card-design__text">
              <p>Выберите один из множества дизайнов<br> подарочных карт на любой вкус и повод!</p>
              <div class="card-design__btn">
                <button class="btn btn_blue" @click="closeSlider()">Выбрать</button>
              </div>
            </div>
            <div class="card-design__images">
              <div v-for="(design, index) in cardDesigns" class="card-design__img" :class="{'active' : index === 0}"><img :src="design.photo" alt="" loading="lazy"></div>
            </div>
          </div>
          <div class="card-design__list" data-tabs=".card-design__images">
            <label v-for="(design, index) in cardDesigns" class="card-design__item" :data-tab-page="index" @click.prevent="setDesign(design)">
              <input type="radio" name="design" :id="'design-'+(index+1)">
              <img :src="design.photo" alt="" loading="lazy">
            </label>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import {email, required} from 'vuelidate/lib/validators'

export default {
  name: "GiftCardReg",
  data()
  {
    return {
      timezones: [],
      cardDesigns: [],
      nominals: [],
      cards: [],
      emptyCardFields: [],
      customer: {
        name: "",
        lastName: "",
        secondName: "",
        email: "",
        phone: "",
        agreement: false,
      },
      emptyCustomerFields: {},
      cardsCount: 1,
      totalSum: null,
      showConfirmModal: false,
      modal: {
        show: false,
        message: "",
      },
      designChooseId: '',
    }
  },
  validations: {
    customer: {
      name: {required},
      lastName: {required},
      secondName: {required},
      email: {required, email},
      phone: {required},
      agreement: {
        checked: function ()
        {
          return this.customer.agreement
        }
      },
    },
  },
  mounted()
  {
    this.fetchInitData();
    this.emptyCustomerFields = JSON.parse( JSON.stringify( this.customer ) );
    this.emptyCardFields = JSON.parse( JSON.stringify( this.cards ) );
  },
  computed:
      {
        removeCardEnable()
        {
          return this.cardsCount > 1;
        },
      },
  watch:
      {
        "customer.name"( newValue, oldValue )
        {
          let matched = newValue.match( /[^А-ЯЁ\s]/gi );
          if ( matched !== null )
          {
            return this.customer.name = oldValue;
          }
        },
        "customer.lastName"( newValue, oldValue )
        {
          let matched = newValue.match( /[^А-ЯЁ\s]/gi );
          if ( matched !== null )
          {
            return this.customer.lastName = oldValue;
          }
        },
        "customer.secondName"( newValue, oldValue )
        {
          let matched = newValue.match( /[^А-ЯЁ\s]/gi );
          if ( matched !== null )
          {
            return this.customer.secondName = oldValue;
          }
        },
        cards:
            {
              deep: true,
              handler()
              {
                let total = 0;
                this.cards.forEach( card =>
                {
                  if ( card.nominal )
                  {
                    total += +card.nominal;
                  }
                } )
                this.totalSum = this.partitionNumber( total );
              }
            }
      },
  methods:
      {
        closeSlider()
        {
          $.fancybox.close();
        },
        setDesignId(id)
        {
          window.initTabs();
          this.designChooseId = id
        },
        setDesign(design)
        {
          this.$children.forEach( comp =>
          {
            if(comp.id  === this.designChooseId)
            {
              comp.fields.design = design.id;
              comp.designChoseLink = design.photo;
            }
          } )
        },
        partitionNumber( number )
        {
          number = parseInt( number );
          return number.toString().replace( /(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1&nbsp;" ) + "&nbsp;руб.";
        },
        fetchInitData()
        {
          fetch( "/api/gift-cards/init-data-values/" )
              .then( data => data.json() )
              .then( data =>
              {
                if ( data.success )
                {
                  this.timezones = data[ "data" ][ 'timezones' ];
                  this.cardDesigns = data[ "data" ][ 'cardDesigns' ];
                }
                else
                {
                  console.error( data.message );
                  this.modal.message = data.message;
                  this.modal.show = true;
                }
              } )
        },
        increaseCard()
        {
          this.cardsCount++;
        },
        decreaseCard( value )
        {
          this.cards.splice( value, 1 );
          this.cardsCount--;
        },
        setFields( value )
        {
          this.$set( this.cards, value.num, value.fields );
        },
        updatePhone( el )
        {
          this.customer.phone = el.target.value;
        },
        addOrder()
        {
          if ( this.cards.length < 1 )
          {
            alert( "Добавьте карты в заказ" );
            return;
          }

          let completed = true;
          this.$children.forEach( component =>
          {
            if ( component.$options.name === "CardDataForm" )
            {
              if ( component.triggerVuelidate() )
              {
                completed = false;
              }
            }
          } )

          this.$v.$touch();
          completed = completed && !this.$v.$invalid;
          if ( !completed )
          {
            return;
          }

          let fd = new FormData;
          fd.append( 'cards', JSON.stringify( this.cards ) );
          fd.append( 'customer', JSON.stringify( this.customer ) );
          fetch( "/api/gift-cards/order/create/", {
            method: "POST",
            body: fd,
          } )
              .then( res => res.json() )
              .then( json =>
              {
                if ( json.success )
                {
                  let data = json[ "data" ];
                  this.modal.message = "Заказ принят, внесите оплату";
                  window.open( data[ "payment-link" ], '_blank' );
                  this.clearForm();
                }
                else
                {
                  this.modal.message = json.message;
                }
                this.modal.show = true;
              } )
        },
        clearForm()
        {
          this.customer = JSON.parse( JSON.stringify( this.emptyCustomerFields ) );
          this.$children.forEach( component =>
          {
            if ( component.$options.name === "CardDataForm" )
            {
              component.clearCard();
              component.deleteCard();
            }
          } )
          this.cards = JSON.parse( JSON.stringify( this.emptyCardFields ) );

          document.querySelector( '[name="cPhone"]' ).value = '';
          document.querySelectorAll( '[name="phone"]' ).forEach( input =>
          {
            input.value = '';
          } )
          this.cardsCount = 1;
          this.$v.$reset();
        }
      }
}
</script>